import { render } from "./MbDisplaypriceDisp.vue?vue&type=template&id=022a5887&scoped=true"
import script from "./MbDisplaypriceDisp.vue?vue&type=script&lang=js"
export * from "./MbDisplaypriceDisp.vue?vue&type=script&lang=js"

import "./MbDisplaypriceDisp.vue?vue&type=style&index=0&id=022a5887&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-022a5887"

export default script